var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnToDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Turn it digital") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Feuille papier convertie en volume numerique.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 166.5 L 456.1 285.3 L 261.7 397.5 L 55.9 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 230.3,
    y1: 194.5,
    x2: 104.5,
    y2: 267.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 274.6,
    y1: 220.1,
    x2: 148.8,
    y2: 292.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 318.9,
    y1: 245.7,
    x2: 193.1,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 363.2,
    y1: 271.3,
    x2: 237.4,
    y2: 343.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 407.5,
    y1: 296.9,
    x2: 281.7,
    y2: 369.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 230.3,
    y1: 194.5,
    x2: 407.5,
    y2: 296.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 188.4,
    y1: 218.8,
    x2: 365.6,
    y2: 321.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 146.4,
    y1: 242.9,
    x2: 323.6,
    y2: 345.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 104.5,
    y1: 267.1,
    x2: 281.7,
    y2: 369.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 213.1 202.8 L 273.1 237.4 L 181.7 290.2 L 121.7 255.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 213.1 202.8 L 273.1 237.4 L 181.7 290.2 L 121.7 255.6 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 208.8,
    y1: 214.8,
    x2: 250.3,
    y2: 238.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 191.1,
    y1: 225.1,
    x2: 232.6,
    y2: 249
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 173.4,
    y1: 235.3,
    x2: 214.8,
    y2: 259.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 155.7,
    y1: 245.5,
    x2: 197.1,
    y2: 269.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 138,
    y1: 255.8,
    x2: 179.4,
    y2: 279.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 flow",
    d: "M 216 234.2 L 261.7 196.2 L 310.3 201.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "drift d4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 398.9 188 L 333.2 225.9 L 333.2 301.8 L 398.9 263.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 267.4 188 L 333.2 225.9 L 333.2 301.8 L 267.4 263.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 333.2 150 L 398.9 188 L 333.2 225.9 L 267.4 188 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 333.2,
    y1: 225.9,
    x2: 333.2,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 333.2,
    y1: 225.9,
    x2: 398.9,
    y2: 263.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 333.2,
    y1: 225.9,
    x2: 267.4,
    y2: 263.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 333.2 150 L 398.9 188 L 333.2 225.9 L 267.4 188 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 398.9,
    y1: 188,
    x2: 398.9,
    y2: 263.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 333.2,
    y1: 225.9,
    x2: 333.2,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 267.4,
    y1: 188,
    x2: 267.4,
    y2: 263.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 398.9,
    y1: 263.9,
    x2: 333.2,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 333.2,
    y1: 301.8,
    x2: 267.4,
    y2: 263.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 367.5 206.1 L 333.2 225.9 L 333.2 265.5 L 367.5 245.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 298.9 206.1 L 333.2 225.9 L 333.2 265.5 L 298.9 245.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 333.2 186.3 L 367.5 206.1 L 333.2 225.9 L 298.9 206.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 333.2,
    y1: 225.9,
    x2: 333.2,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 333.2,
    y1: 225.9,
    x2: 367.5,
    y2: 245.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 333.2,
    y1: 225.9,
    x2: 298.9,
    y2: 245.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "M 333.2 186.3 L 367.5 206.1 L 333.2 225.9 L 298.9 206.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 367.5,
    y1: 206.1,
    x2: 367.5,
    y2: 245.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 333.2,
    y1: 225.9,
    x2: 333.2,
    y2: 265.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 298.9,
    y1: 206.1,
    x2: 298.9,
    y2: 245.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 367.5,
    y1: 245.7,
    x2: 333.2,
    y2: 265.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 333.2,
    y1: 265.5,
    x2: 298.9,
    y2: 245.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 216,
    cy: 234.2,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 216,
    cy: 234.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d4",
    cx: 261.7,
    cy: 196.2,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 261.7,
    cy: 196.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d8",
    cx: 310.3,
    cy: 201.1,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 310.3,
    cy: 201.1,
    r: 3.6
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnToDigital);
export default __webpack_public_path__ + "static/media/turn-to-digital.8f9e5b1072ea0eabfea9cb2ca6e7c2c6.svg";
export { ForwardRef as ReactComponent };